import { sendEventToJumbo } from './jumbo';

export const KEBAB_MENU_EVENTS = {
  KEBAB_MENU_OPEN_EVENT: 'kebab_menu_open_event',
  KEBAB_MENU_CLOSE_EVENT: 'kebab_menu_close_event',
  KEBAB_MENU_SELECTED_ITEM: 'kebab_menu_selected_item',
  KEBAB_MENU_MODAL_OPEN: 'kebab_menu_modal_open',
  KEBAB_MENU_MODAL_CLOSE: 'kebab_menu_modal_close',
  SEND_NOTIFICATION_TO_VALET_SUCCESS: 'send_notification_to_valet_success',
  SEND_NOTIFICATION_TO_VALET_FAILURE: 'send_notification_to_valet_failure',
  SUBMIT_ESCALATION_SUCCESS: 'submit_escalation_success',
  SUBMIT_ESCALATION_FAILURE: 'submit_escalation_failure',
  GET_ESCALATION_REASONS_SUCCESS: 'get_escalation_reasons_success',
  GET_ESCALATION_REASONS_FAILURE: 'get_escalation_reasons_failure',
  GET_USER_PROMO_DETAILS_SUCCESS: 'get_user_promo_details_success',
  GET_USER_PROMO_DETAILS_FAILURE: 'get_user_promo_details_failure',
  GET_ACTIVE_USER_PROMO_TAB_EVENT: 'get_active_user_promo_tab_event',
  GET_USER_ESCALATION_DETAILS_SUCCESS: 'get_user_escalation_details_success',
  GET_USER_ESCALATION_DETAILS_FAILURE: 'get_user_escalation_details_failure',
  CHANGE_USER_ESCALATION_PRIORITY_SUCCESS:
    'change_user_escalation_priority_success',
  CHANGE_USER_ESCALATION_PRIORITY_FAILURE:
    'change_user_escalation_priority_failure',
  GET_LINKED_USER_DETAILS_SUCCESS: 'get_linked_user_details_success',
  GET_LINKED_USER_DETAILS_FAILURE: 'get_linked_user_details_failure',
  GET_USER_GIFT_CARD_DETAILS_SUCCESS: 'get_user_gift_card_details_success',
  GET_USER_GIFT_CARD_DETAILS_FAILURE: 'get_user_gift_card_details_failure',
  GET_USER_NUMBER_DETAILS_SUCCESS: 'get_user_number_details_success',
  GET_USER_NUMBER_DETAILS_FAILURE: 'get_user_number_details_failure',
  UNLINK_USER_NUMBER_SUCCESS: 'unlink_user_number_success',
  UNLINK_USER_NUMBER_FAILURE: 'unlink_user_number_failure',
  GET_PROMO_CODE_SUCCESS: 'get_promo_code_details_success',
  GET_PROMO_CODE_FAILURE: 'get_promo_code_details_failure',
  PROMO_DOWNLOAD_CSV_SUCCESS: 'promo_download_csv_success',
  PROMO_DOWNLOAD_CSV_FAILURE: 'promo_download_csv_failure',
  GET_ZPL_HISTORY_SUCCESS: 'get_zpl_history_success',
  GET_ZPL_HISTORY_FAILURE: 'get_zpl_history_failure',
  GET_ZPL_REWARDS_SUCCESS: 'get_zpl_rewards_success',
  GET_ZPL_REWARDS_FAILURE: 'get_zpl_rewards_failure',
};

export const sendKebabMenuEvents = (
  eventName,
  orderId,
  customerId,
  responseMeta = {},
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta: {
      ...responseMeta,
      isNewUser: !orderId && customerId ? 'true' : 'false',
    },
  });
};
